// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"552":"rules","794":"cases","964":"billing"}[chunkId] || chunkId) + "." + {"12":"36a20324","552":"e4b157bf","794":"6ac4d879","865":"93425c51","964":"66e97b51"}[chunkId] + ".css";
};